import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Gallery from "@/pages/Gallery";
import HowItWorks from "@/pages/HowItWorks";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Book from "@/pages/Book";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";
import MyBookings from "@/pages/MyBookings";
import ContractorPortal from "@/pages/ContractorPortal";
import ContractorOnboarding from "@/pages/ContractorOnboarding";
import AdminDashboard from "@/pages/AdminDashboard";
import Reviews from "@/pages/Reviews";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/book" element={<Book />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancelled" element={<PaymentCancelled />} />
            <Route path="/me/bookings" element={
              <ProtectedRoute roles={["customer"]}><MyBookings /></ProtectedRoute>
            } />
            <Route path="/contractor" element={
              <ProtectedRoute roles={["contractor"]}><ContractorPortal /></ProtectedRoute>
            } />
            <Route path="/contractor/onboarding" element={
              <ProtectedRoute roles={["contractor"]}><ContractorOnboarding /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
